<template>
    <div>
        <b-row class="pricing-card">
            <b-col>
                <b-card>
                    <b-row>
                        <b-col md="12" cols="12" class="text-center">
                            <h1 class="m-1">Pricing Plans</h1>
                            <p>
                                You have a voucher?
                                <b-link :to="{ name: 'voucher' }"
                                    >Redeem a voucher</b-link
                                >
                                or
                                <b-link :to="{ name: 'resellers' }"
                                    >Check our resellers</b-link
                                >
                            </p>
                            <p>
                                Want the latest deals? Follow us on Telegram for
                                discount codes and special offers:
                                <a
                                    href="https://t.me/leechallcom"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    >@leechallcom</a
                                >
                            </p></b-col
                        >

                        <b-col md="6" cols="12">
                            <b-card class="popular">
                                <b-list-group
                                    class="list-group-circle text-left"
                                >
                                    <b-list-group-item
                                        >60+ Filehosts</b-list-group-item
                                    >
                                    <b-list-group-item
                                        >200 GB Daily
                                        Bandwidth</b-list-group-item
                                    >
                                    <b-list-group-item
                                        >High Speed Download</b-list-group-item
                                    >
                                </b-list-group>
                            </b-card></b-col
                        ><b-col md="6" cols="12">
                            <b-card class="popular">
                                <b-list-group
                                    class="list-group-circle text-left"
                                >
                                    <b-list-group-item
                                        >Secure Account Access</b-list-group-item
                                    >
                                    <b-list-group-item
                                        >24/7 Customer
                                        Support</b-list-group-item
                                    >
                                    <b-list-group-item
                                        >No Ads - No Waiting
                                        Time</b-list-group-item
                                    >
                                </b-list-group>
                            </b-card>
                        </b-col>
                        <b-col md="12" cols="12">
                            <b-card
                                class="purchase-notice-card"
                                title="Please Read Before You Purchase"
                            >
                                <b-card-text class="text-left mb-75">
                                    Please review these details to make sure the
                                    service fits your needs.
                                </b-card-text>
                                <ul
                                    class="purchase-notice-list text-left mb-0"
                                >
                                    <li>
                                        <strong
                                            >Host status &amp; service
                                            limits:</strong
                                        >
                                        Check the current
                                        <b-link :to="{ name: 'status' }"
                                            >host status and limits</b-link
                                        >
                                        before purchasing. Daily bandwidth, file
                                        size, and link limits may apply and can
                                        change based on host availability.
                                    </li>
                                    <li>
                                        <strong>File availability:</strong>
                                        Availability may vary by host and
                                        individual file. Some files may require
                                        a separate subscription, verification,
                                        or special access from the original host
                                        and may not be downloadable through our
                                        service.
                                    </li>
                                    <li>
                                        <strong>Activation &amp; refunds:</strong>
                                        Activated plans, keys, and vouchers
                                        cannot be revoked and are non-refundable,
                                        except where required by law.
                                    </li>
                                    <li>
                                        <strong
                                            >Questions before purchasing?</strong
                                        >
                                        We’re happy to help via
                                        <a
                                            href="https://t.me/ndt258"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            >Telegram</a
                                        >
                                        or
                                        <a href="mailto:support@leechall.io"
                                            >support@leechall.io</a
                                        >.
                                    </li>
                                </ul>
                            </b-card>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="4" v-for="item in items" :key="item.id">
                            <b-card align="center" border-variant="primary">
                                <h3>{{ item.name }}</h3>
                                <div class="annual-plan border-top">
                                    <div class="plan-price mt-2">
                                        <sup
                                            class="font-medium-1 font-weight-bold text-primary"
                                            >{{ toSymbols(item.currency) }}</sup
                                        >
                                        <span
                                            class="pricing-basic-value font-weight-bolder text-primary"
                                            >{{ item.price }}</span
                                        >
                                    </div>
                                </div>
                                <!-- buttons -->
                                <b-button
                                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                    block
                                    class="mt-2"
                                    variant="outline-primary"
                                    @click="onPurchase(item.id)"
                                >
                                    Purchase
                                </b-button>
                            </b-card>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>

        <!-- Modal show payments -->
        <b-modal
            v-model="show"
            hide-footer
            title="Please choose payment method"
        >
            <b-list-group flush class="mb-1">
                <b-list-group-item
                    button
                    v-for="item in payments"
                    :key="item.id"
                    @click="onPayment(item.id)"
                >
                    <b-img
                        :src="iconPayment(item.logo)"
                        class="mr-1 payment-icon"
                    />
                    <p class="float-left">
                        <strong class="d-block">{{ item.name }}</strong>
                        <small>{{ item.description }}</small>
                    </p>
                </b-list-group-item>
            </b-list-group>
            <small
                >Can't find any suitable payment method?
                <b-link :to="{ name: 'resellers' }">Check our resellers</b-link>
                or contact us.</small
            >
        </b-modal>
    </div>
</template>

<script>
import {
    BRow,
    BCol,
    BCard,
    BCardText,
    BListGroup,
    BListGroupItem,
    BButton,
    BLink,
    BModal,
    VBModal,
    BAvatar,
    BImg,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { saveCheckoutIntent } from "@/utils/checkout-intent";
export default {
    components: {
        BRow,
        BCol,
        BCard,
        BCardText,
        BListGroup,
        BListGroupItem,
        BButton,
        BLink,
        BModal,
        BAvatar,
        BImg,
    },
    directives: {
        "b-modal": VBModal,
        Ripple,
    },
    created() {
        this.$gtag.event("view_plans");
        this.fetchPlans();
        this.fetchPayments();
    },
    computed: {
        toSymbols() {
            return (currency) => {
                var currency_symbols = {
                    USD: "$", // US Dollar
                    EUR: "€", // Euro
                    CRC: "₡", // Costa Rican Colón
                    GBP: "£", // British Pound Sterling
                    ILS: "₪", // Israeli New Sheqel
                    INR: "₹", // Indian Rupee
                    JPY: "¥", // Japanese Yen
                    KRW: "₩", // South Korean Won
                    NGN: "₦", // Nigerian Naira
                    PHP: "₱", // Philippine Peso
                    PLN: "zł", // Polish Zloty
                    PYG: "₲", // Paraguayan Guarani
                    THB: "฿", // Thai Baht
                    UAH: "₴", // Ukrainian Hryvnia
                    VND: "₫", // Vietnamese Dong
                };
                return currency_symbols[currency.toUpperCase()];
            };
        },
        iconPayment() {
            return (data) => "images/payments/methods/" + data + ".png";
        },
    },
    data() {
        return {
            show: false,
            items: [],
            payments: [],
            plan_id: null,
        };
    },
    methods: {
        fetchPlans() {
            this.$store
                .dispatch("fetchPlans")
                .then((res) => (this.items = res.data))
                .catch((err) => console.log(err));
        },
        fetchPayments() {
            this.$store
                .dispatch("fetchPaymentMethods")
                .then((res) => (this.payments = res.data.data))
                .catch((err) => console.log(err));
        },
        onPayment(id) {
            const checkoutRoute = {
                name: "payment-summary",
                params: { plan_id: this.plan_id, payment_id: id },
            };
            const checkoutPath = this.$router.resolve(checkoutRoute).route
                .fullPath;

            saveCheckoutIntent(checkoutPath);
            this.$gtag.event("select_payment", {
                plan_id: String(this.plan_id),
                payment_id: String(id),
            });
            this.$router.push(checkoutRoute);
        },
        onPurchase(id) {
            this.$gtag.event("select_plan", {
                plan_id: String(id),
            });
            this.show = true;
            this.plan_id = id;
        },
    },
};
</script>

<style lang="scss">
.pricing-free-trial {
    margin-top: 2.5rem !important;
}
.payment-icon {
    float: left;
}
.purchase-notice-list {
    padding-left: 1.25rem;
}
.purchase-notice-card {
    background-color: #fff;
    border: 1px solid #7367f0;
    border-left: 3px solid rgba(255, 159, 67, 0.75);
}
.purchase-notice-list li {
    margin-bottom: 0.5rem;
    line-height: 1.45;
}
.purchase-notice-list li:last-child {
    margin-bottom: 0;
}
@import "@core/scss/vue/pages/page-pricing.scss";
</style>
